import { Box } from "@mui/material";

interface AppLayoutWrapperDesktopProps {
  children: React.ReactNode;
}

/**
 * Top level wrapper for the app layout
 * Renders the entire app layout and wraps the header, inner content (nav menu and page content)
 */
export function AppLayoutWrapperDesktop(props: AppLayoutWrapperDesktopProps) {
  const { children } = props;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: 0,
        background: theme.palette.navbar?.background,
        height: "100vh",
      })}
    >
      {children}
    </Box>
  );
}
